import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { Button, Stack, Typography } from '@mui/material';
import useFrameworkTranslation from 'framework/language/useFrameworkTranslation';
import AryModal from './AryModal';
import ArchiveAccountCheckout from './ArchiveAccountCheckout';
import ArchiveBankCheckout from './ArchiveBankCheckout';

const ArchiveAccountErrorAlert = ({ open, error, type, onClose }) => {
  const { t } = useFrameworkTranslation();
  const [showCheckoutBranchModal, setShowCheckoutBranchModal] = useState(false);
  const [showCheckoutBankModal, setShowCheckoutBankModal] = useState(false);
  const theme = useTheme();

  const handleCheckout = () => {
    if (type === 'Branch-EX-Branch_Cant_Archive') {
      setShowCheckoutBranchModal(true);
    } else if (type === 'BANK-Ex-CANT_ARCHIVE_BALANCE_MUST_BE_ZERO') {
      setShowCheckoutBankModal(true);
    }
    onClose();
  };

  return (
    <>
      <AryModal
        open={open}
        handleClose={onClose}
        title={t('actionArchive')}
        content={error}
      >
        <Stack
          direction="column"
          width="100%"
          gap={theme.padding.gridColumnSpacing}
        >
          <Typography marginLeft={theme.padding.gridColumnSpacing}>
            {error}
          </Typography>
          <Stack direction="row" gap={2} width="100%" justifyContent="flex-end">
            <Button onClick={onClose}>{t('Cancel')}</Button>
            <Button variant="contained" onClick={handleCheckout}>
              {t('Checkout')}
            </Button>
          </Stack>
        </Stack>
      </AryModal>
      {showCheckoutBranchModal && (
        <ArchiveAccountCheckout
          open={showCheckoutBranchModal}
          handleClose={() => setShowCheckoutBranchModal(false)}
        />
      )}
      {showCheckoutBankModal && (
        <ArchiveBankCheckout
          open={showCheckoutBankModal}
          handleClose={() => setShowCheckoutBankModal(false)}
        />
      )}
    </>
  );
};

export default ArchiveAccountErrorAlert;
